import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class EditCustomerCollectionsEmailResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                "collections_email": "cobranzas@dundermifflin.com"
            },
            errors: []
        }
    }

    collectionsEmail() {
        return this.content().collections_email;
    }
}
